export const GET_PRICING_PLANS = "GET_PRICING_PLANS";
export const GET_PRICING_PLAN_BY_ID = "GET_PRICING_PLAN_BY_ID";
export const UPDATE_PRICING_PLAN = "UPDATE_PRICING_PLAN";
export const DELETE_PRICING_PLAN = "DELETE_PRICING_PLAN";
export const CREATE_PRICING_PLAN = "CREATE_PRICING_PLAN";
